var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "button-window-container",
      class: { open: _vm.isOpen, fixed: _vm.isFixed }
    },
    [
      _c(
        "missing-permissions-tooltip",
        {
          attrs: {
            "missing-permissions-list": _vm.listMissingPermissions
              ? _vm.listMissingPermissions
              : []
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "button-container",
              class: { disabled: _vm.isFixed || _vm.disabled },
              on: { click: _vm.toggleWindow }
            },
            [
              _vm._t("buttonIcon"),
              _vm._v(" "),
              _vm.isOpen
                ? [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "25px",
                          "text-align": "left"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.windowName) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.dev
                      ? _c("dev-tag", {
                          style: { "margin-left": "15px" },
                          attrs: { position: "relative" }
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isOpen ? _vm._t("refreshButton") : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen"
            }
          ],
          staticClass: "window-content-container"
        },
        [
          _c("hr", { staticClass: "home-window-hr" }),
          _vm._v(" "),
          _vm._t("windowContent")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-233092b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233092b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Network/NetworkButtonWindow.vue
// module id = null
// module chunks = 